
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPinSelectedGoogle as ObiPinSelectedGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-pin-selected-google.js';
 
 
 

 
 export const ObiPinSelectedGoogle = createComponent({
   react: React,
   tagName: 'obi-pin-selected-google',
   elementClass: ObiPinSelectedGoogleElement,
   events: {
     
   }
  });
 
 